@import '../../../../../constants/spacing.module.less';

.returnCarrierHeading {
  padding: @space-24 0 @space-8 0;
}

.returnServiceBannerError {
  margin-top: @space-24;
}

.modalContent {
  display: flex;
  flex-direction: column;
}

.returnServiceOptions {
  margin: @space-16 0;
}

.radioOption {
  margin-bottom: @space-16;
  border: 1px solid var(--gray-E0E0E0);
  border-radius: 4px;
  padding: @space-12;
}

.selectedRadioOption {
  background-color: var(--gray-F7F7F8);
  border: 2px solid var(--blue-11003A);
}

.radioOptionContent {
  display: flex;
  flex-direction: column;
  gap: @space-8;
  margin-left: @space-8;
}

.radioCheckListItem {
  padding: 0;
}

.radioOptionLabel {
  font-weight: 500;
}

.dropdownContainer {
  display: flex;
  flex-direction: row;
  gap: @space-16;
}

.dropdownSection {
  display: flex;
  flex-direction: column;
  gap: @space-4;
  flex: 1;
}
